import { render, staticRenderFns } from "./notificationEdit.vue?vue&type=template&id=3f770dcc&scoped=true"
import script from "./notificationEdit.vue?vue&type=script&lang=js"
export * from "./notificationEdit.vue?vue&type=script&lang=js"
import style0 from "./notificationEdit.vue?vue&type=style&index=0&id=3f770dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f770dcc",
  null
  
)

export default component.exports